import React from 'react'
import LayoutDefault from '../../layouts/Default'
import { Async } from 'react-async'
import fetchData from '../../modules/fetch-data'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'

const ScreenTraffic = loadable(() =>
  import(/* webpackChunkName: "ScreenTraffic" , webpackPrefetch: true */ './screens/ScreenTraffic'),
)

const Traffic = ({ initialData, match, location, ...props }) => (
  <Async promiseFn={fetchData} location={location.pathname} watch={location} initialValue={initialData}>
    {({ data, error, isPending, isFulfilled }) => {
      let timeout = data && data.data && data.data.timeout

      return (
        <LayoutDefault meta={isFulfilled && data.meta} {...props}>
          <ScreenTraffic
            error={error}
            loading={isPending || timeout}
            response={isFulfilled && !timeout && data}
            {...props}
          />
        </LayoutDefault>
      )
    }}
  </Async>
)

Traffic.getInitialData = ({ req }) => {
  return fetchData({ location: req.url })
}

Traffic.propTypes = {
  initialData: PropTypes.shape({
    meta: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    config: PropTypes.object,
  }),
  location: PropTypes.object,
  match: PropTypes.object,
}

Traffic.defaultProps = {
  location: {
    pathname: undefined,
  },
}

export default Traffic
